import { storeTypeToDisplayName } from "@faire/retailer-visitor-shared/lib/storeTypeToDisplayName";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { StoreType } from "@faire/web--source/common/StoreType";
import sortBy from "lodash/sortBy";
import { useMemo } from "react";

export const useStoreTypeOptions = () => {
  const { strictLocalize } = useStrictLocalization();

  return useMemo(() => {
    return sortBy(
      Object.values(StoreType)
        .map((value) => ({
          label: storeTypeToDisplayName(value, strictLocalize),
          value,
        }))
        .filter((option) => option.value !== StoreType.OTHER),
      "label"
    ).concat({
      label: storeTypeToDisplayName(StoreType.OTHER, strictLocalize),
      value: StoreType.OTHER,
    });
  }, [strictLocalize]);
};
